<template>
	<v-container class="noMargin">			
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRICELISTS') !== -1">					
			<v-flex lg12>        
				<div class="pageTitle">
					<h2>PRICELISTS</h2>
				</div>	
				<v-btn @click.prevent="fncAddPricelist" class="elevation-5" color="info"><i class="material-icons">add</i>Create Pricelist</v-btn>                
				<v-btn @click.prevent="fncReloadPricelists" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>		
    </v-container>	
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
			fncAddPricelist() {
                var modalDetails = { title: 'Add Pricelist', component: 'modal-pricelist-add-new', mstate: true };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
            },
            fncReloadPricelists() {
              this.$store.commit('fncEmptyPricelists');              
              this.$store.dispatch({
                type: 'fncPopulatePricelistList',
                reload: true
              })
              this.$store.dispatch({
                type: 'fncPopulatePricingTable',
                reload: true
              })
            }
		},
		computed: {
			...mapGetters([			
              'objAuthorize',
              'priceTableAll'		
			])
		} 	
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>